import { derived } from 'svelte/store';
import type { ProductCmsAiAccessSummary } from '$lib/api/modules-access';
import { loadModulesAccess, modulesAccess, modulesAccessState, resetModulesAccess } from './modulesAccess';

export type { ProductCmsAiAccessSummary } from '$lib/api/modules-access';

export const productCmsAiAccess = derived(modulesAccess, ($modulesAccess) => $modulesAccess.productCmsAi);
export const isLoadingProductCmsAiAccess = derived(modulesAccessState, ($state) => $state.status === 'refreshing');

export async function loadProductCmsAiAccess(force = false): Promise<void> {
  await loadModulesAccess(force);
}

export function resetProductCmsAiAccess(): void {
  resetModulesAccess();
}